<template>
  <button
    :disabled="disabled"
    :style="btnColor"
    @click="$emit('click', $event)"
    class=" rounded focus:outline-none"
    :class="[btnClasses]"
  >
    <slot></slot>
  </button>
</template>
<script>
import colors from "@/utils/colors";
export default {
  // If you want the theme color to be used for the button
  // dont pass any color prop, if you want a specific color, pass it
  props: {
    size: {
      type: String,
      default: "md",
    },
    border: {
      type: Boolean,
      default: false
    },
    transparent: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    hasBorderColor: {},
    color: {},
    textColor: {
      type: String,
    },
  },
  data() {
    return {
      sizes: {
        sm: ["py-2", "px-2", "text-xs"],
        md: ["py-2", "px-8"],
      },
      colors: Object.values(colors),
    };
  },
  computed: {
    btnClasses() {
      let classes = ""
      if(this.border) {
        classes +=` border`
      }
      classes+= this.transparent == true ? ' noBack' : ''
      classes+=" "+this.sizes[this.size].join(" ");
      return classes
    },
    btnColor() {
      let styles = ""
      if(typeof(this.hasBorderColor) !== "undefined") {
        styles+= `border-color: ${this.hasBorderColor}; `
      }      

      if(typeof(this.color) == "undefined") {
        if(typeof(this.textColor) !== "undefined") {
          styles+=`color: ${this.textColor} !important; `
        }else {
          styles+=`color: #fff; `
        }
      }else {
        styles+= `background-color: ${this.color}; font-weight: 600;`;
      }

      return styles
    },
  },
};
</script>
<style lang="scss" scoped>
.noBack {
  background-color: rgba(255, 255, 255, .1) !important;
}
button {
  color: color(lms-tenant);
  background-color: color(lms-tenant);
}
</style>
